
import { Config as CFG } from '@configs/index.config';
export class Config extends CFG {
  
}
